import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "../../components/Layout";
import { submitOrganizerApplication } from "../../api/organizer";

const COMMISSION_RATE = 8;
const COMMISSION = `${COMMISSION_RATE}%`;
// Nümunə hesablama üçün bilet qiyməti
const EXAMPLE_PRICE = 100;
const EXAMPLE_FEE = (EXAMPLE_PRICE * COMMISSION_RATE) / 100;

const benefits = [
  {
    title: "Geniş auditoriya",
    desc: "Tədbirinizi minlərlə aktiv istifadəçiyə təqdim edin və satışlarınızı artırın.",
    color: "accent",
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" />
    ),
  },
  {
    title: "Təhlükəsiz ödənişlər",
    desc: "Bank kartları ilə qorunan ödənişlər. Pul birbaşa hesabınıza köçürülür.",
    color: "emerald",
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z" />
    ),
  },
  {
    title: "Canlı idarə paneli",
    desc: "Satışları, gəliri və qonaq siyahısını real vaxtda izləyin — istənilən cihazdan.",
    color: "indigo",
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z" />
    ),
  },
  {
    title: "QR biletlər",
    desc: "Hər bilet üçün avtomatik QR kod. Girişdə sürətli və saxtakarlığa qarşı yoxlama.",
    color: "pink",
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 013.75 9.375v-4.5zM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 01-1.125-1.125v-4.5zM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0113.5 9.375v-4.5z" />
    ),
  },
  {
    title: "Sürətli ödəmələr",
    desc: "Tədbirdən sonra 3–5 iş günü ərzində qazancınız hesabınıza köçürülür.",
    color: "amber",
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 18L9 11.25l4.306 4.307a11.95 11.95 0 015.814-5.519l2.74-1.22m0 0l-5.94-2.28m5.94 2.28l-2.28 5.941" />
    ),
  },
  {
    title: "Marketinq dəstəyi",
    desc: "Tədbiriniz ana səhifədə və sosial şəbəkələrimizdə tanıdılır — əlavə ödənişsiz.",
    color: "accent",
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" d="M10.34 15.84c-.688-.06-1.386-.09-2.09-.09H7.5a4.5 4.5 0 110-9h.75c.704 0 1.402-.03 2.09-.09m0 9.18c.253.962.584 1.892.985 2.783.247.55.06 1.21-.463 1.511l-.657.38c-.551.319-1.26.116-1.527-.461a20.845 20.845 0 01-1.44-4.282m3.102.069a18.03 18.03 0 01-.59-4.59c0-1.586.205-3.124.59-4.59m0 9.18a23.848 23.848 0 018.835 2.535M10.34 6.66a23.847 23.847 0 008.835-2.535m0 0A23.74 23.74 0 0018.795 3m.38 1.125a23.91 23.91 0 011.014 5.395m-1.014 8.855c-.118.38-.245.754-.38 1.125m.38-1.125a23.91 23.91 0 001.014-5.395m0-3.46c.495.413.811 1.035.811 1.73 0 .695-.316 1.317-.811 1.73m0-3.46a24.347 24.347 0 010 3.46" />
    ),
  },
];

const steps = [
  { n: "1", title: "Müraciət edin", desc: "Aşağıdakı formanı doldurun. Bir neçə dəqiqə çəkir." },
  { n: "2", title: "Təsdiq alın", desc: "Komandamız 1–2 iş günü ərzində sizinlə əlaqə saxlayır və hesabınızı yaradır." },
  { n: "3", title: "Tədbir yaradın", desc: "İdarə panelindən tədbirinizi, bilet tiplərini və qiymətləri əlavə edin." },
  { n: "4", title: "Satış başlasın", desc: "Tədbiriniz dərc olunur, biletlər satılır, gəliriniz hesablanır." },
];

const rules = [
  "Tədbir məlumatları (tarix, məkan, qiymət) dəqiq və doğru olmalıdır.",
  "Yalnız qanuni və icazəli tədbirlər yerləşdirilə bilər.",
  "Tədbir ləğv olunarsa, biletlər tam məbləğdə geri ödənilir.",
  "Komissiya yalnız satılan biletlərdən tutulur — satış yoxdursa, ödəniş yoxdur.",
  "İstifadəçi məlumatları məxfi saxlanılır və üçüncü tərəflə paylaşılmır.",
  "Tixy.az saxta və ya yanıldıcı tədbirləri silmək hüququnu özündə saxlayır.",
];

const faqs = [
  {
    q: "Qoşulmaq üçün ödəniş etməliyəmmi?",
    a: "Xeyr. Qoşulma, aylıq abunə və ya gizli ödəniş yoxdur. Yalnız satılan biletlərdən " + COMMISSION + " komissiya tutulur.",
  },
  {
    q: "Pulumu nə vaxt alıram?",
    a: "Tədbir bitdikdən sonra 3–5 iş günü ərzində qazancınız (komissiya çıxıldıqdan sonra) bank hesabınıza köçürülür.",
  },
  {
    q: "Hansı tədbirləri sata bilərəm?",
    a: "Konsertlər, festivallar, teatr, idman, seminar, master-klass və digər qanuni tədbirlər — hamısı platformamızda yerləşdirilə bilər.",
  },
  {
    q: "Biletlər necə yoxlanılır?",
    a: "Hər bilet unikal QR kodla təchiz olunur. Girişdə kodu skan edərək biletin həqiqiliyini bir saniyədə yoxlaya bilərsiniz.",
  },
];

const colorMap = {
  accent: "from-accent-500/10 to-accent-600/10 border-accent-500/10 text-accent-500",
  emerald: "from-emerald-500/10 to-emerald-600/10 border-emerald-500/10 text-emerald-500",
  indigo: "from-indigo-500/10 to-indigo-600/10 border-indigo-500/10 text-indigo-500",
  pink: "from-pink-500/10 to-pink-600/10 border-pink-500/10 text-pink-500",
  amber: "from-amber-500/10 to-amber-600/10 border-amber-500/10 text-amber-500",
};

const initialForm = {
  organizationName: "",
  contactName: "",
  email: "",
  phone: "",
  website: "",
  eventTypes: "",
  expectedEvents: "",
  audienceSize: "",
  message: "",
  agree: false,
};

const OrganizerPage = () => {
  const [form, setForm] = useState(initialForm);
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [error, setError] = useState("");
  const formRef = useRef(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };

  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!form.organizationName || !form.contactName || !form.email || !form.phone) {
      setError("Zəhmət olmasa, ulduzla işarələnmiş sahələri doldurun.");
      return;
    }
    if (!form.agree) {
      setError("Davam etmək üçün şərtlər və qaydalarla razılaşmalısınız.");
      return;
    }

    try {
      setStatus("loading");
      const { agree, ...payload } = form;
      await submitOrganizerApplication(payload);
      setStatus("success");
      setForm(initialForm);
    } catch (err) {
      setStatus("error");
      setError(
        err?.response?.data?.message ||
          "Müraciət göndərilmədi. Zəhmət olmasa, bir az sonra yenidən cəhd edin."
      );
    }
  };

  const inputClass =
    "w-full rounded-xl border border-surface-200 bg-white px-4 py-3 text-surface-900 placeholder-surface-400 outline-none transition focus:border-accent-500 focus:ring-2 focus:ring-accent-500/20";

  return (
    <Layout>
      {/* Hero */}
      <section className="relative bg-surface-950 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-mesh opacity-20" />
        <div className="absolute top-1/3 left-1/4 w-80 h-80 bg-accent-600/15 rounded-full blur-[120px] animate-float" />
        <div className="absolute bottom-1/4 right-1/3 w-64 h-64 bg-pink-600/15 rounded-full blur-[100px] animate-float-delayed" />

        <div className="relative max-w-4xl mx-auto px-6 lg:px-8 pt-32 pb-20 text-center">
          <div className="flex items-center justify-center gap-2 text-sm font-semibold mb-6">
            <Link to="/" className="text-surface-500 hover:text-white transition">Ana Səhifə</Link>
            <svg className="w-3.5 h-3.5 text-surface-600" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
            </svg>
            <span className="text-white/70">Tədbirinizi satın</span>
          </div>

          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full glass text-accent-300 text-xs font-semibold mb-6">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-400 animate-pulse" />
            Təşkilatçılar üçün
          </div>

          <h1 className="text-4xl md:text-6xl font-extrabold text-white tracking-tight leading-tight mb-6">
            Tədbirinizi <span className="text-gradient">Tixy</span>-də satın
          </h1>
          <p className="text-lg text-surface-400 max-w-2xl mx-auto leading-relaxed font-light mb-10">
            Konsert, festival, teatr və ya seminar — hər tədbiri dəqiqələr içində onlayn satışa çıxarın.
            Qoşulma haqqı yoxdur, yalnız satılan biletlərdən {COMMISSION} komissiya.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <button
              onClick={scrollToForm}
              className="inline-flex items-center gap-2 bg-white text-surface-900 font-semibold px-8 py-3.5 rounded-2xl hover:shadow-[0_20px_60px_-10px_rgba(139,92,246,0.4)] transition-all duration-500"
            >
              Müraciət et
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
              </svg>
            </button>
            <a
              href="#necə-işləyir"
              className="inline-flex items-center gap-2 glass text-white font-medium px-8 py-3.5 rounded-2xl hover:bg-white/[0.15] transition-all duration-300"
            >
              Necə işləyir?
            </a>
          </div>

          {/* Trust stats */}
          <div className="mt-16 grid grid-cols-3 gap-6 max-w-xl mx-auto">
            {[
              { value: COMMISSION, label: "komissiya" },
              { value: "0 ₼", label: "qoşulma haqqı" },
              { value: "3–5 gün", label: "ödəmə müddəti" },
            ].map((s) => (
              <div key={s.label}>
                <div className="text-2xl md:text-3xl font-extrabold text-white">{s.value}</div>
                <div className="text-xs text-surface-500 mt-1">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="bg-white">
        <div className="max-w-6xl mx-auto px-6 lg:px-8 py-20 md:py-28">
          <div className="text-center max-w-2xl mx-auto mb-14">
            <h2 className="text-3xl md:text-4xl font-bold text-surface-900 mb-4">Niyə Tixy?</h2>
            <p className="text-surface-500 text-lg">
              Bilet satışının bütün texniki tərəfini biz öz üzərimizə götürürük — siz yalnız tədbirinizə fokuslanın.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {benefits.map((b) => (
              <div
                key={b.title}
                className="group bg-surface-50 rounded-3xl p-7 border border-surface-100 hover:border-surface-200 hover:shadow-lg transition-all duration-300"
              >
                <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${colorMap[b.color]} border flex items-center justify-center mb-5`}>
                  <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                    {b.icon}
                  </svg>
                </div>
                <h3 className="text-lg font-bold text-surface-900 mb-2">{b.title}</h3>
                <p className="text-surface-500 leading-relaxed text-sm">{b.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How it works */}
      <section id="necə-işləyir" className="bg-surface-50 border-y border-surface-100">
        <div className="max-w-6xl mx-auto px-6 lg:px-8 py-20 md:py-28">
          <div className="text-center max-w-2xl mx-auto mb-14">
            <h2 className="text-3xl md:text-4xl font-bold text-surface-900 mb-4">Necə işləyir?</h2>
            <p className="text-surface-500 text-lg">Müraciətdən ilk satışa qədər cəmi dörd addım.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            {steps.map((s, i) => (
              <div key={s.n} className="relative">
                <div className="bg-white rounded-3xl p-7 border border-surface-100 h-full">
                  <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-accent-500 to-pink-500 text-white font-bold flex items-center justify-center mb-5">
                    {s.n}
                  </div>
                  <h3 className="text-lg font-bold text-surface-900 mb-2">{s.title}</h3>
                  <p className="text-surface-500 text-sm leading-relaxed">{s.desc}</p>
                </div>
                {i < steps.length - 1 && (
                  <svg className="hidden md:block absolute top-1/2 -right-4 w-6 h-6 text-surface-300 -translate-y-1/2 z-10" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                  </svg>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing / commission */}
      <section className="bg-white">
        <div className="max-w-5xl mx-auto px-6 lg:px-8 py-20 md:py-28">
          <div className="bg-gradient-to-br from-surface-950 to-surface-800 rounded-3xl p-10 md:p-14 relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-mesh opacity-15" />
            <div className="absolute top-0 right-0 w-72 h-72 bg-accent-600/20 rounded-full blur-[120px]" />

            <div className="relative grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
              <div>
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full glass text-accent-300 text-xs font-semibold mb-5">
                  Sadə və şəffaf qiymət
                </div>
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                  Yalnız satışdan <span className="text-gradient">{COMMISSION}</span>
                </h2>
                <p className="text-surface-400 leading-relaxed mb-6">
                  Gizli ödəniş yoxdur. Qoşulma və aylıq abunə pulsuzdur. Komissiya yalnız real satılan biletlərdən tutulur —
                  bilet satılmırsa, heç nə ödəmirsiniz.
                </p>
                <ul className="space-y-3">
                  {[
                    "Qoşulma və aylıq haqq — 0 ₼",
                    "Ödəniş emalı komissiyaya daxildir",
                    "Tədbirdən sonra 3–5 iş günü ödəmə",
                    "İstənilən vaxt ləğv etmə imkanı",
                  ].map((item) => (
                    <li key={item} className="flex items-start gap-3 text-surface-300 text-sm">
                      <svg className="w-5 h-5 text-emerald-400 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clipRule="evenodd" />
                      </svg>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="bg-white/[0.04] border border-white/10 rounded-3xl p-8 text-center">
                <div className="text-sm text-surface-400 mb-2">Hər satılan biletdən</div>
                <div className="text-6xl font-extrabold text-white mb-2">{COMMISSION}</div>
                <div className="text-surface-400 text-sm mb-6">komissiya — başqa heç nə</div>
                <div className="border-t border-white/10 pt-6 text-left space-y-3">
                  <div className="flex justify-between text-sm">
                    <span className="text-surface-400">Bilet qiyməti</span>
                    <span className="text-white font-medium">{EXAMPLE_PRICE} ₼</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-surface-400">Tixy komissiyası ({COMMISSION})</span>
                    <span className="text-white font-medium">−{EXAMPLE_FEE} ₼</span>
                  </div>
                  <div className="flex justify-between text-base pt-3 border-t border-white/10">
                    <span className="text-white font-semibold">Sizə qalan</span>
                    <span className="text-emerald-400 font-bold">{EXAMPLE_PRICE - EXAMPLE_FEE} ₼</span>
                  </div>
                </div>
                <button
                  onClick={scrollToForm}
                  className="mt-7 w-full bg-white text-surface-900 font-semibold py-3.5 rounded-2xl hover:shadow-[0_20px_60px_-10px_rgba(139,92,246,0.4)] transition-all duration-500"
                >
                  İndi müraciət et
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Rules */}
      <section className="bg-surface-50 border-y border-surface-100">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 py-20 md:py-24">
          <div className="text-center max-w-2xl mx-auto mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-surface-900 mb-4">Şərtlər və qaydalar</h2>
            <p className="text-surface-500 text-lg">Platformamızda etibarlı və ədalətli mühit üçün bir neçə sadə qayda.</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {rules.map((rule, i) => (
              <div key={i} className="flex items-start gap-3 bg-white rounded-2xl p-5 border border-surface-100">
                <svg className="w-5 h-5 text-accent-500 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clipRule="evenodd" />
                </svg>
                <span className="text-surface-600 text-sm leading-relaxed">{rule}</span>
              </div>
            ))}
          </div>
          <p className="text-center text-xs text-surface-400 mt-8">
            Ətraflı şərtlərlə <Link to="/privacy-policy" className="text-accent-500 hover:underline">Məxfilik Siyasəti</Link> səhifəsində tanış ola bilərsiniz.
          </p>
        </div>
      </section>

      {/* Application form */}
      <section ref={formRef} className="bg-white scroll-mt-24">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 py-20 md:py-28">
          <div className="text-center max-w-2xl mx-auto mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-surface-900 mb-4">Müraciət formu</h2>
            <p className="text-surface-500 text-lg">
              Formanı doldurun — komandamız 1–2 iş günü ərzində sizinlə əlaqə saxlayıb hesabınızı yaradacaq.
            </p>
          </div>

          {status === "success" ? (
            <div className="bg-emerald-50 border border-emerald-200 rounded-3xl p-10 text-center">
              <div className="w-16 h-16 rounded-2xl bg-emerald-500 flex items-center justify-center mx-auto mb-5">
                <svg className="w-9 h-9 text-white" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-surface-900 mb-3">Müraciətiniz göndərildi! 🎉</h3>
              <p className="text-surface-600 max-w-md mx-auto mb-6">
                Təşəkkür edirik. Komandamız müraciətinizi nəzərdən keçirib qısa zamanda sizinlə əlaqə saxlayacaq.
                Təsdiq e-poçtunu e-poçt qutunuzda yoxlayın.
              </p>
              <button
                onClick={() => setStatus("idle")}
                className="inline-flex items-center gap-2 text-accent-600 font-semibold hover:text-accent-700 transition"
              >
                Yeni müraciət göndər
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="bg-surface-50 rounded-3xl p-7 md:p-10 border border-surface-100 space-y-5">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div>
                  <label className="block text-sm font-medium text-surface-700 mb-1.5">
                    Təşkilat / Brend adı <span className="text-accent-500">*</span>
                  </label>
                  <input name="organizationName" value={form.organizationName} onChange={handleChange} className={inputClass} placeholder="Məs: Baku Events" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-surface-700 mb-1.5">
                    Əlaqədar şəxs <span className="text-accent-500">*</span>
                  </label>
                  <input name="contactName" value={form.contactName} onChange={handleChange} className={inputClass} placeholder="Ad Soyad" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-surface-700 mb-1.5">
                    E-poçt <span className="text-accent-500">*</span>
                  </label>
                  <input type="email" name="email" value={form.email} onChange={handleChange} className={inputClass} placeholder="siz@nümunə.az" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-surface-700 mb-1.5">
                    Telefon <span className="text-accent-500">*</span>
                  </label>
                  <input name="phone" value={form.phone} onChange={handleChange} className={inputClass} placeholder="+994 ..." />
                </div>
                <div className="sm:col-span-2">
                  <label className="block text-sm font-medium text-surface-700 mb-1.5">Vebsayt / Sosial şəbəkə</label>
                  <input name="website" value={form.website} onChange={handleChange} className={inputClass} placeholder="instagram.com/... və ya vebsayt" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-surface-700 mb-1.5">Tədbir növü</label>
                  <input name="eventTypes" value={form.eventTypes} onChange={handleChange} className={inputClass} placeholder="Konsert, festival, seminar..." />
                </div>
                <div>
                  <label className="block text-sm font-medium text-surface-700 mb-1.5">İl ərzində tədbir sayı</label>
                  <select name="expectedEvents" value={form.expectedEvents} onChange={handleChange} className={inputClass}>
                    <option value="">Seçin</option>
                    <option value="1">1 tədbir</option>
                    <option value="2-5">2–5 tədbir</option>
                    <option value="6-12">6–12 tədbir</option>
                    <option value="12+">12-dən çox</option>
                  </select>
                </div>
                <div className="sm:col-span-2">
                  <label className="block text-sm font-medium text-surface-700 mb-1.5">Təxmini auditoriya (hər tədbir)</label>
                  <select name="audienceSize" value={form.audienceSize} onChange={handleChange} className={inputClass}>
                    <option value="">Seçin</option>
                    <option value="<100">100-dən az</option>
                    <option value="100-500">100–500</option>
                    <option value="500-2000">500–2000</option>
                    <option value="2000+">2000-dən çox</option>
                  </select>
                </div>
                <div className="sm:col-span-2">
                  <label className="block text-sm font-medium text-surface-700 mb-1.5">Əlavə qeyd</label>
                  <textarea name="message" value={form.message} onChange={handleChange} rows={4} className={inputClass} placeholder="Tədbiriniz haqqında qısa məlumat..." />
                </div>
              </div>

              <label className="flex items-start gap-3 cursor-pointer">
                <input
                  type="checkbox"
                  name="agree"
                  checked={form.agree}
                  onChange={handleChange}
                  className="mt-1 w-5 h-5 rounded border-surface-300 text-accent-500 focus:ring-accent-500/30"
                />
                <span className="text-sm text-surface-600">
                  Şərtlər və qaydalarla, həmçinin {COMMISSION} komissiya modeli ilə razıyam.
                </span>
              </label>

              {error && (
                <div className="bg-red-50 border border-red-200 text-red-600 text-sm rounded-xl px-4 py-3">
                  {error}
                </div>
              )}

              <button
                type="submit"
                disabled={status === "loading"}
                className="w-full bg-gradient-to-br from-accent-500 to-pink-500 text-white font-semibold py-4 rounded-2xl hover:shadow-[0_20px_60px_-10px_rgba(139,92,246,0.5)] transition-all duration-500 disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {status === "loading" ? "Göndərilir..." : "Müraciəti göndər"}
              </button>

              <p className="text-center text-xs text-surface-400">
                Müraciət göndərməklə heç bir öhdəlik götürmürsünüz. Bütün suallarınızı təsdiqdən əvvəl müzakirə edə bilərik.
              </p>
            </form>
          )}
        </div>
      </section>

      {/* FAQ */}
      <section className="bg-surface-50 border-t border-surface-100">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 py-20 md:py-24">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-surface-900 mb-4">Tez-tez verilən suallar</h2>
          </div>
          <div className="space-y-4">
            {faqs.map((faq) => (
              <details key={faq.q} className="group bg-white rounded-2xl border border-surface-100 overflow-hidden">
                <summary className="flex items-center justify-between gap-4 cursor-pointer px-6 py-5 list-none">
                  <span className="font-semibold text-surface-900">{faq.q}</span>
                  <svg className="w-5 h-5 text-surface-400 flex-shrink-0 transition-transform duration-300 group-open:rotate-180" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                  </svg>
                </summary>
                <p className="px-6 pb-5 text-surface-500 text-sm leading-relaxed">{faq.a}</p>
              </details>
            ))}
          </div>

          <div className="mt-12 text-center">
            <p className="text-surface-500 mb-4">Başqa sualınız var?</p>
            <a href="mailto:info@tixy.az" className="inline-flex items-center gap-2 text-accent-600 font-semibold hover:text-accent-700 transition">
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
              </svg>
              info@tixy.az
            </a>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default OrganizerPage;
